import { Provider } from "jotai";
import { useContext } from "react";
import tools from "../../../../../../helpers/tools";
import AssignationLead from "../../../../../common/CarteLead/AssignationLead";
import { FORMAT_LONG } from "../../../../../common/CarteLead/MetaCarte";
import PanneauLead from "../../../../../common/CarteLead/PanneauLead";
import ProduitLead from "../../../../../common/CarteLead/ProduitLead";
import StatutLead from "../../../../../common/CarteLead/StatutLead";
import CommentList from "../../../../../common/CommentList/CommentList";
import TodoList from "../../../../../common/TodoList/TodoList";
import { LeadPageContext } from "../../../useLeads";
import { LeadContext } from "../../LeadContext";
import { extrasOnglets } from "../carte/extrasOnglets";
import { filtreCandidatsAssignation, nomDuLead, produitDuLead } from "../profilLead";
import useLeadItem from "../useLeadItem";
import DemandesLiees from "./DemandesLiees";
import InfosLead from "./InfosLead";

// Panneau de détail d'un lead entreprise ou DOMI : le panneau du kit commun
// avec la ligne d'état (statut, assignation, type de demande) et le contenu de
// chaque section (infos et documents, commentaires, tâches, demandes liées).
const PanneauLeadEntreprise = ({ ton = "primary", puceType, constants }) => {
  const { productCategory } = useContext(LeadPageContext);
  const { lead, actions } = useLeadItem();
  const { tasksByProduct, managers, contacts, panneau } = useContext(LeadContext);
  const produit = produitDuLead(lead, productCategory, constants);

  const contenu = (onglet) => {
    switch (onglet) {
      case "commentaires":
        return (
          <Provider>
            <CommentList
              initComments={lead.comments || []}
              onUpdateComments={actions.onUpdateComments}
              onUpdateComment={actions.onUpdateComment}
              onAddComment={actions.onAddComment}
              onDeleteComment={actions.onDeleteComment}
              users={contacts}
            />
          </Provider>
        );
      case "taches":
        return (
          <Provider>
            <TodoList
              initTodos={lead.tasks || []}
              tasksByProduct={tasksByProduct}
              onUpdateTodos={actions.onUpdateTasks}
              onUpdateTodo={actions.onUpdateTask}
              onAddTodo={actions.onAddTask}
              onDeleteTodo={actions.onDeleteTask}
              users={managers}
            />
          </Provider>
        );
      case "liees":
        return <DemandesLiees />;
      case "infos":
      default:
        return <InfosLead />;
    }
  };

  return (
    <PanneauLead
      idCarte={`leaditem${lead.id}`}
      leadId={lead.id}
      panneau={panneau}
      ton={ton}
      produit={<ProduitLead {...produit} petit />}
      titre={nomDuLead(lead, productCategory)}
      sousTitre={[
        `Lead ${productCategory === "DOMI" ? "DOMI" : "entreprise"}`,
        produit.nom.toUpperCase() !== produit.code ? produit.nom : null,
        `créé le ${tools.formatDate(lead.createdAt, FORMAT_LONG)}`,
      ]
        .filter(Boolean)
        .join(" · ")}
      etat={
        <>
          <StatutLead lead={lead} onUpdateStatus={actions.onUpdateStatus} portee="panneau" />
          <AssignationLead
            leadId={lead.id}
            assignedTo={lead.assignedTo}
            managers={managers}
            onAssigner={(id) => actions.onUpdateAssignTo(id, Boolean(lead.assignedTo))}
            filtrerCandidat={filtreCandidatsAssignation(productCategory)}
            portee="panneau"
          />
          {puceType}
        </>
      }
      extra={extrasOnglets(lead)}
      contenu={contenu}
    />
  );
};

export default PanneauLeadEntreprise;
